<header>
  <img
    class="header__logo"
    src="/assets/img/logo.svg"
    alt="Logo banco Pichincha PERÚ"
    (click)="clickedLogo()"
  />

  <img
    class="header__logo-mobile"
    src="/assets/img/logo-mobile.svg"
    alt="Logo banco Pichincha PERÚ"
    (click)="clickedLogo()"
  />

  <!--<div class="header_current_steps" *ngIf="showCurrentProduct && !error">
    <label class="current-steps-title">
      {{currentProductTitle}}
    </label>
  </div> -->

  <div class="header_current_buttons-container" *ngIf="showMoreInformationProduct && !error">
    <label *ngIf="currentProduct=='ACC'"  class="current-steps-button" (click)="gotoPublicWeb('_blank', false)">
      Ver Beneficios 
      <ui-icon 
        class="icon-header-button" 
        color="#104798"  
        width="14"
        height="14"
        name="cheveron_next">
      </ui-icon>
      <ui-icon 
        class="icon-header-button-mobile" 
        color="#104798"  
        width="19"
        height="19"
        name="cheveron_next">

      </ui-icon>
    </label>

    <label *ngIf="currentProduct=='FTD'"  class="current-steps-button" (click)="gotoPublicWebDPF('_blank', false)">
      Conoce más aqui
      <ui-icon 
        class="icon-header-button" 
        color="#104798"  
        width="14"
        height="14"
        name="cheveron_next">
      </ui-icon>
      <ui-icon 
        class="icon-header-button-mobile" 
        color="#104798"  
        width="19"
        height="19"
        name="cheveron_next">

      </ui-icon>
    </label>
  </div>


  <div class="header__actions" *ngIf="showLoanOptions && !error">
    <div class="header__phone">
      <ui-text color="blue-500" size="tiny">
        <ui-icon class="phone-ico" name="phone"></ui-icon>
        <span class="phone-text">Lima: 612-2222</span>
      </ui-text>
    </div>

    <ui-button
      (clicked)="simulateLoan()"
      type="secondary-default"
      icon-name="tune"
      size="sm"
      icon-position="left"
      label="Simula tu préstamo"
    ></ui-button>


  </div>
</header>
<shell-out-office
  *ngIf="!outOfficeData.isAvailable || !outOfficeData.allowedSchedule"
  [outOfficeData]="outOfficeData"
></shell-out-office>
<div *ngIf="routerOutlet">
  <!-- Quit all components when is outOffice -->
  <div [hidden]="!!error || hiddenRouterOutLet">
    <router-outlet></router-outlet>
  </div>

  <shell-handle-errors *ngIf="error" [error]="error"></shell-handle-errors>
</div>
<div [ngSwitch]="footerType">
  <ng-container *ngSwitchCase="footerDefault">
    <footer>
      <div class="container text-center">
        <ui-text
          class="default__copy-right"
          align="center"
          weight="medium"
          size="small"
          color="blue-500"
        >
          RUC: 20100105862 / BANCO PICHINCHA.
        </ui-text>
        <ui-text
          class="default__copy-right"
          align="center"
          weight="medium"
          size="small"
          color="blue-500"
        >
          Todos los derechos reservados.
        </ui-text>
      </div>
    </footer>
  </ng-container>

  <ng-container *ngSwitchCase="footerHome">
    <div class="container-footer-home">
      <footer class="home">
        <ui-text
          class="all-rights-reserved"
          align="center"
          weight="medium"
          size="tiny"
          color="blue-500"
        >
          RUC: 20100105862 / BANCO PICHINCHA. Todos los derechos reservados.
        </ui-text>
      </footer>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="footerLoan">
    <footer>
      <div class="container container-footer-loan">
        <ui-text
          class="default__copy-right"
          align="center"
          weight="medium"
          size="small"
          color="blue-500"
        >
          Para consultas comunicarse con nuestra Banca Telefónica al 01 612-2222 (Lima) ó
          0-801-00222 (Provincias).
        </ui-text>
        <br />
        <ui-text
          class="default__copy-right"
          align="center"
          weight="medium"
          size="small"
          color="blue-500"
        >
          Av. Ricardo Palma Nro. 278 Res. Miraflores, Lima.
        </ui-text>
        <br />
        <br />
        <ui-text
          class="default__copy-right"
          align="center"
          weight="medium"
          size="small"
          color="blue-500"
        >
          RUC: 20100105862 / BANCO PICHINCHA. Todos los derechos reservados.
        </ui-text>
      </div>
    </footer>
  </ng-container>
  <ng-container *ngSwitchCase="footerFtd">
    <div class="container-footer-ftd">
      <footer class="home">
        <ui-text
          class="all-rights-reserved"
          align="center"
          weight="medium"
          size="tiny"
          color="blue-500"
        >
          RUC: 20100105862 / BANCO PICHINCHA. Todos los derechos reservados.
        </ui-text>
      </footer>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="footerFtdConfig">
    <div class="container-footer-ftd">
      <footer class="ftd">
        <ui-text
          class="all-rights-reserved"
          align="center"
          weight="medium"
          size="tiny"
          color="blue-500"
        >
          RUC: 20100105862 / BANCO PICHINCHA. Todos los derechos reservados.
        </ui-text>
      </footer>
    </div>
  </ng-container>
</div>
